import { useNavigate } from 'react-router-dom';
import { cn } from 'lib/utils';

function ItemCard({ imgSrc, title, description, onClick }) {
  return (
    <div
      className="tw-flex-1 tw-flex tw-flex-col tw-items-center tw-text-center tw-px-6 tw-py-5 tw-cursor-pointer hover:tw-underline tw-rounded-2xl tw-transition"
      onClick={onClick}
    >
      <div className="tw-w-48 tw-h-48 tw-flex tw-items-center tw-justify-center tw-rounded-full tw-bg-gray-800 tw-mb-4">
        <img className="tw-w-48 tw-h-48 tw-object-contain" src={imgSrc} alt={title} />
      </div>
      <h3 className="tw-text-2xl tw-font-extrabold tw-text-gray-900 tw-mb-2">{title}</h3>
      <p className="tw-text-gray-600 tw-text-xl tw-max-w-xs">{description}</p>
    </div>
  );
}

export default function HorizontalLanding({ meta, session, className }) {
  const navigate = useNavigate();
  const items = meta.items.filter((item) => session.permissions[item.permission]);

  return (
    <div
      className={cn(
        'lg:tw-flex lg:tw-justify-between lg:tw-items-start tw-gap-8 tw-px-12 tw-py-10 tw-w-full tw-mx-auto',
        className,
      )}
    >
      {items.map((item) => (
        <ItemCard
          key={item.path}
          title={item.title}
          description={item.description}
          imgSrc={item.imgSrc}
          onClick={() => {
            navigate({ pathname: `${meta.path}${item.path}` }, { replace: false });
          }}
        />
      ))}
    </div>
  );
}

export function splitMeta(meta, parts) {
  const { items, ...rest } = meta;
  const size = Math.ceil(items.length / parts);

  return Array.from({ length: parts }, (_, i) => ({
    ...rest,
    items: items.slice(i * size, (i + 1) * size),
  }));
}
